import { render, staticRenderFns } from "./VariantPickerProductHiddenField.vue?vue&type=template&id=22338490&"
import script from "./VariantPickerProductHiddenField.vue?vue&type=script&lang=js&"
export * from "./VariantPickerProductHiddenField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports